/*globals jQuery,ScrollMagic,TimelineMax,TweenMax,Power0,Power2,Power3,imagesLoaded */

( function ( $, sr ) {
	'use strict';

	// debouncing function from John Hann
	// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	// https://www.paulirish.com/2009/throttled-smartresize-jquery-event-handler/
	var debounce = function ( func, threshold, execAsap ) {
		var timeout;

		return function debounced() {
			var obj = this,
				args = arguments;

			function delayed() {
				if ( !execAsap ) {
					func.apply( obj, args );
				}
				timeout = null;
			}

			if ( timeout ) {
				clearTimeout( timeout );
			} else if ( execAsap ) {
				func.apply( obj, args );
			}

			timeout = setTimeout( delayed, threshold || 100 );
		};
	};

	// smartresize
	jQuery.fn[ sr ] = function ( fn ) {
		return fn ? this.bind( 'resize', debounce( fn ) ) : this.trigger( sr );
	};

} )( jQuery, 'smartresize' );

( function ( $ ) {
	'use strict';

	var ratioW = $( window ).width() / 1750;

	var methods = {

		'homepage': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#screen1 .tree-left', 0.65, {
						filter: 'blur(0px)',
						scale: 1 * ratioW,
					}, {
						left: '-100vw',
						scale: 2 * ratioW,
						opacity: 0,
						filter: 'blur(15px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .tree-middle', 0.9, {
						filter: 'blur(0px)',
						scale: 1 * ratioW,
					}, {
						bottom: '-30vh',
						scale: 1.5 * ratioW,
						opacity: 0,
						filter: 'blur(10px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .tree-right', 0.45, {
						filter: 'blur(0px)',
						scale: 1 * ratioW,
					}, {
						right: '-105vw',
						scale: 2.5 * ratioW,
						opacity: 0,
						filter: 'blur(20px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .home-building', 1, {
						bottom: '-30vh',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .home-building', 1, {
						bottom: '-100vh'
					}, {
						bottom: '-30vh',
						zIndex: 105,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .home-title', 1, {
						filter: 'blur(0px)'
					}, {
						y: '-=150vh',
						filter: 'blur(25px)',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#main .circles', 1, {
						y: '-=150vh',
						scale: 4,
						opacity: 0,
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#main .lt-circles', 1, {
						y: '150vh',
						scale: 0.15
					}, {
						y: '0vh',
						scale: 1,
						opacity: 1,
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1', 1, {
						zIndex: 150,
						delay: 1,
					} ),
					TweenMax.to( '#screen1 .home-text-block-1', 1, {
						x: '-100%',
						y: '-100%',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .home-side-panel-fake', 1, {
						left: '150vw',
						bottom: '0'
					}, {
						left: '60vW',
						bottom: '0vh',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .home-side-panel', 1, {
						left: '150vw',
						bottom: '0'
					}, {
						left: '60vW',
						bottom: '0vh',
						delay: 1,
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '200%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

		},




		'story-1': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles', 1, {
						scale: 4,
						opacity: 0,
						ease: Power0.easeNone
					} ),
					TweenMax.fromTo( '#screen1 .st1-title', 1, {
						filter: 'blur(0px)',
					}, {
						top: '-100vh',
						opacity: 0,
						filter: 'blur(25px)',
						ease: Power0.easeNone
					} ),
					TweenMax.fromTo( '#screen1 .st1-building', 1, {
						top: '60vh',
						filter: 'blur(0px)',
					}, {
						filter: 'blur(25px)',
						top: '200vh',
						ease: Power2.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

			// text and round building
			var tl2 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen2', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen2 .st1-building-2', 1, {
						top: '-100vh',
						scale: 0.5,
						boxShadow: '0 0 0 30px rgba(226,226,217,0.5), 0 0 0 80px rgba(226,226,217,.15)'
					}, {
						top: '50vh',
						scale: 1,
						boxShadow: '0 0 0 120px rgba(226,226,217,1), 0 0 0 320px rgba(226,226,217,.25)',
						ease: Power0.easeNone
					} ),
					TweenMax.fromTo( '#screen2 .st1-text-block-1', 1, {
						top: '200vh'
					}, {
						top: '50vh',
						ease: Power0.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen2' ).setTween( tl2 ).addTo( controller );

			// searching video
			var tl3 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen2 .st1-building-2', 1, {
						top: '-100vh',
						scale: 0.5,
						boxShadow: '0 0 0 30px rgba(226,226,217,0.5), 0 0 0 80px rgba(226,226,217,.15)',
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen2 .st1-text-block-1', 1, {
						top: '-100vh'
					} ),
					TweenMax.to( '#main .circles', 1, {
						scale: 0.45,
						top: '-50vh',
						left: '60vw',
						opacity: 0.75,
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen3 .st1-search-video', 1, {
						top: '150vh'
					}, {
						top: '50vh',
						ease: Power0.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel2',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen3' ).setTween( tl3 ).addTo( controller );

			// interior
			var tl4 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen3 .st1-search-video', 1, {
						top: '-65vh'
					} ),
					TweenMax.to( '#main .circles', 1, {
						scale: 0.45,
						top: '-125vh',
						opacity: 0,
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen4', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen4 .st1-text-block-2', 1, {
						top: '150vh'
					}, {
						top: '50vh',
						ease: Power0.easeNone
					} ),
					TweenMax.fromTo( '#screen4 .st1-interior', 1, {
						top: '125vh'
					}, {
						top: '-10vh',
						ease: Power0.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel3',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen4' ).setTween( tl4 ).addTo( controller );

			// be my neighbor video
			var tl5 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .lt-circles', 1, {
						top: '125vh',
						left: '-150vw',
						opacity: 0,
						scale: 2
					}, {
						top: '30vh',
						left: '-50vw',
						scale: 1,
						opacity: 0.75,
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen4 .st1-text-block-2', 1, {
						top: '-125vh'
					} ),
					TweenMax.to( '#screen4 .st1-interior', 1, {
						top: '125vh'
					} ),
					TweenMax.to( '#screen4', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen5', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen5 .st1-neighbor-video', 1, {
						top: '150vh'
					}, {
						top: '50vh',
						ease: Power0.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel4',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen5' ).setTween( tl5 ).addTo( controller );

			// large small text
			var tl6 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .lt-circles', 1, {
						top: 0,
						left: 0,
						scale: 1,
						opacity: 0.75,
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen5 .st1-neighbor-video', 1, {
						top: '-65vh'
					} ),
					TweenMax.to( '#screen5', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen6', 1, {
						zIndex: 150
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel5',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen6' ).setTween( tl6 ).addTo( controller );




			// large small text
			var tl6r = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#screen6 .st1-text-block-3', 1, {
						top: '150vh'
					}, {
						top: '50vh',
						ease: Power0.easeNone
					} ),
					TweenMax.fromTo( '#screen6 .st1-text-block-3 p', 1, {
						left: '-150vw'
					}, {
						left: '0',
						ease: Power0.easeNone
					} ),
					TweenMax.fromTo( '#screen6 .st1-text-block-3 h4', 1, {
						right: '-150vw'
					}, {
						right: '0',
						ease: Power0.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel5',
				offset: -400,
				duration: '100%'
			} ).setTween( tl6r ).addTo( controller );



			// grid
			var tl7 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .lt-circles', 1, {
						top: '-=60vh',
						left: '170vw',
						scale: 0.5,
						opacity: 0,
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen6 .st1-text-block-3', 1, {
						top: '-=100vh',
						ease: Power0.easeNone
					} ),
					TweenMax.to( '#screen6', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen7', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen7 .photo-grid', 1, {
						top: '100vh'
					}, {
						top: '0vh',
						ease: Power0.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel6',
				triggerHook: 'onEnter',
				duration: '90%'
			} ).setPin( '#screen7' ).setTween( tl7 ).addTo( controller );

		},



		'story-2': function ( controller ) {

			var XAngle = 0;
			var YAngle = 0;
			var Z = 50;

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .circles', 1, {
						scale: 3.5,
						top: '120vh'
					}, {
						scale: 2.25,
						top: '-250vh',
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st2-title', 1, {
						filter: 'blur(0px)',
					}, {
						top: '-100vh',
						opacity: 0,
						filter: 'blur(50px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .st2-map', 1, {
						top: '-200vh',
						ease: Power2.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

			var tl2 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#screen2 .st2-family-img-solo', 1, {
						top: '135vh',
						left: '0vw',
						scale: 0.1
					}, {
						top: '45vh',
						left: '20vw',
						scale: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st2-compass-img', 1, {
						top: '150vh',
						left: '2vw',
						scale: 0.1,
					}, {
						top: '70vh',
						left: '35vw',
						scale: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen2 .st2-text-block-1', 1, {
						top: '-150vh'
					}, {
						top: '40vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st2-text-block-2', 1, {
						top: '200vh'
					}, {
						top: '43vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st2-blue-box', 1, {
						left: '-150vw'
					}, {
						left: '47vw',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen2' ).setTween( tl2 ).addTo( controller );

			var tl3 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen2 .st2-family-img-solo', 1, {
						top: '-100vh',
						left: '0vw',
						scale: 2,
						rotation: -30,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st2-compass-img', 1, {
						top: '-70vh',
						left: '80vw',
						scale: 3,
						rotation: 60,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st2-text-block-1', 1, {
						top: '-150vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st2-text-block-2', 1, {
						top: '-150vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st2-blue-box', 1, {
						left: '150vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen3 .st2-swing-img', 1, {
						left: '-45vh',
						rotation: 63
					}, {
						left: '-20vh',
						rotation: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen3 .st2-side-panel', 1, {
						rotationY: -270,
						rotationX: -90,
						left: '150vw',
						bottom: '150vh'
					}, {
						rotationY: 0,
						rotationX: 0,
						left: '60vW',
						bottom: '0vh',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel2',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen3' ).setTween( tl3 ).addTo( controller );

			// box rollover
			function mapRollover() {

				$( window ).on( 'mousemove', function ( e ) {

					var $selector = $( '#screen1 .st2-map' );
					var $selector2 = $( '#screen1 .st2-title' );
					var XRel = e.pageX;
					var YRel = e.pageY;
					var width = $selector.width();

					YAngle = -( 0.5 - XRel / width );
					XAngle = ( 0.5 - YRel / width );

					$selector.css( {

						transform: 'perspective(1500px) translateX(-50%) translateY(-50%) translateZ(-50px) rotateX(' + ( XAngle * 20 ) + 'deg) rotateY(' + ( YAngle * 20 ) + 'deg)',
						transition: 'none',
						'-webkit-transition': 'none'

					} );

					$selector2.css( {

						transform: 'perspective(1500px) translateX(-50%) translateY(-50%) translateZ(50px) rotateX(' + ( XAngle * 5 ) + 'deg) rotateY(' + ( YAngle * 5 ) + 'deg)',
						transition: 'none',
						'-webkit-transition': 'none'

					} );

				} );

				$( window ).on( 'mouseleave', function () {

					var $selector = $( '#screen1 .st2-map' );

					$selector.css( {
						transform: 'perspective(1500px) translateX(-50%) translateY(-50%) translateZ(0) rotateX(0deg) rotateY(0deg)',
						transition: 'all 150ms linear 0s',
						'-webkit-transition': 'all 150ms linear 0s'
					} );

				} );
			}

			mapRollover();

		},



		'story-3': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .circles', 1, {
						top: '0vh',
						right: '-98.75vw',
						scale: 3
					}, {
						top: '10vh',
						right: '-60vw',
						scale: 1,
						opacity: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st3-blurry-tree', 1, {
						left: '82.65vw',
						scale: 3
					}, {
						left: '220vw',
						top: '200vh',
						scale: 2.25,
						opacity: 0,
						ease: Power2.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st3-title', 1, {
						filter: 'blur(0px)',
					}, {
						top: '-100vh',
						opacity: 0,
						filter: 'blur(50px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .st3-girl', 1, {
						bottom: '-200vh',
						ease: Power2.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

			var tl2 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .circles-2', 1, {
						top: '200vh',
						left: '-65vw',
						scale: 3,
						opacity: 0
					}, {
						top: '105vh',
						scale: 1.65,
						opacity: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen2 .st3-family-img', 1, {
						top: '150vh'
					}, {
						top: '50vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st3-text-block-1', 1, {
						top: '-150vh'
					}, {
						top: '20vh',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen2' ).setTween( tl2 ).addTo( controller );

			var tl3 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles-2', 1, {
						top: '110vh',
						left: '-55vw',
						scale: 3,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#main .circles', 1, {
						left: '200vw',
						scale: 3,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st3-family-img', 1, {
						left: '150vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st3-text-block-1', 1, {
						left: '-150vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen3 .st3-headshot-img', 1, {
						bottom: '-150vh'
					}, {
						bottom: '0vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen3 .st3-blurry-trees-2-img', 1, {
						left: '-150vh'
					}, {
						left: '0vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen3 .st3-white-box', 1, {
						top: '150vh',
						filter: 'blur(30px)'
					}, {
						top: '60vh',
						filter: 'blur(0px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen4 .st3-colorful-dots', 1, {
						top: '150vh',
						left: '70vw'
					}, {
						top: '104vh',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel2',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen3' ).setTween( tl3 ).addTo( controller );

			// interior
			var tl4 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles-2', 1, {
						top: '-150vh',
						left: '150vw',
						scale: 5,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen3 .st3-headshot-img', 1, {
						bottom: '100vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen3 .st3-blurry-trees-2-img', 1, {
						bottom: '100vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen3 .st3-white-box', 1, {
						top: '-80vh',
						filter: 'blur(0px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen4', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen4 .st3-baby-feet-video', 1, {
						top: '100vh'
					}, {
						top: '0vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen4 .st3-colorful-dots', 1, {
						top: '80vh',
						left: '73vw',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel3',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen4' ).setTween( tl4 ).addTo( controller );

		},



		'story-4': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .circles-2', 1, {
						top: '-100vh',
						scale: 3.4
					}, {
						top: '-112vh',
						left: '100vw',
						scale: 1.6,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st4-title', 1, {
						filter: 'blur(0px)'
					}, {
						left: '-150vw',
						opacity: 0,
						filter: 'blur(50px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st4-cover-graphic-img', 1, {
						filter: 'blur(0px)'
					}, {
						right: '-85vw',
						opacity: 0,
						filter: 'blur(20px)'
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

			var tl2 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen1', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen2 .st4-text-block-1 h4', 1, {
						top: '-100vh'
					}, {
						top: '-30vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st4-white-box-1', 1, {
						left: '-150vw'
					}, {
						left: '0',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st4-text-block-2', 1, {
						right: '-150vw'
					}, {
						right: '0',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen2' ).setTween( tl2 ).addTo( controller );

			var tl3 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen2 .st4-text-block-1 h4', 1, {
						top: '-80vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st4-white-box-1', 1, {
						top: '-50vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st4-text-block-2', 1, {
						top: '-50vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen3 .st4-learn-more-img', 1, {
						top: '150vh',
						left: '120vw',
						scale: 2
					}, {
						top: '38vh',
						left: '58vw',
						scale: 1,
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel2',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen3' ).setTween( tl3 ).addTo( controller );

			var tl4 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles-2', 0.85, {
						top: '-=100vh',
						scale: 0.25,
						ease: Power2.easeOut
					} ),
					TweenMax.to( '#screen2 .st4-white-box-1', 1, {
						top: '-=100vh',
						ease: Power2.easeOut
					} ),
					TweenMax.to( '#screen2 .st4-text-block-2', 1, {
						top: '-=100vh',
						ease: Power2.easeOut
					} ),
					TweenMax.to( '#screen3 .st4-learn-more-img', 1, {
						top: '-=100vh',
						ease: Power2.easeOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel3',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen3' ).setTween( tl4 ).addTo( controller );

		},



		'story-5': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .circles', 1, {
						x: '-19%',
						scale: 2.2
					}, {
						x: '-=100vw',
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st5-title', 1, {
						filter: 'blur(0px)'
					}, {
						y: '-=100vh',
						opacity: 0,
						filter: 'blur(50px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st5-blur-trees,#screen1 .st5-cover-graphic-img', 1, {
						filter: 'blur(0px)'
					}, {
						left: '-=100vw',
						opacity: 0,
						filter: 'blur(20px)'
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onEnter',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

			var tl2 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#screen2 .st5-text-block-1', 1, {
						top: '-100vh'
					}, {
						top: '25vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st5-text-block-2', 1, {
						top: '-100vh'
					}, {
						top: '44vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st5-globe-1', 1, {
						x: '-=150vw'
					}, {
						x: '0%',
						delay: 0.66,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st5-globe-2', 1, {
						x: '-=150vw'
					}, {
						x: '0%',
						delay: 0.33,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen2 .st5-globe-3', 1, {
						x: '-=150vw'
					}, {
						x: '0%',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen2' ).setTween( tl2 ).addTo( controller );

			var tl3 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen2 .st5-text-block-1', 1, {
						top: '-=150vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st5-text-block-2', 1, {
						top: '-=125vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st5-globe-1', 1, {
						y: '-=100vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st5-globe-2', 1, {
						y: '-=100vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st5-globe-3', 1, {
						y: '-=100vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 150
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 150
					} ),
					TweenMax.fromTo( '#screen3 .st5-text-block-3', 0.85, {
						top: '150vh'
					}, {
						top: '20vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen3 .st5-white-box', 0.8, {
						bottom: '-50vh'
					}, {
						bottom: '20vh',
						delay: 0.1,
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel2',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen3' ).setTween( tl3 ).addTo( controller );

			var tl4 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen3 .st5-text-block-3', 1, {
						top: '-=100vh',
						delay: 0.25,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen3 .st5-white-box', 1, {
						bottom: '+=200vh',
						delay: 0.25,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen3 .st5-whos-ready-video', 1, {
						y: '100%'
					}, {
						y: '-50%',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel3',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen4' ).setTween( tl4 ).addTo( controller );

		},



		'story-6': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.fromTo( '#main .circles-2', 1, {
						x: '-17.5vw',
						scale: 2.5
					}, {
						left: '-=100vw',
						scale: 3,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-title', 1, {
						filter: 'blur(0px)',
					}, {
						left: '-=125vh',
						opacity: 0,
						filter: 'blur(25px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-blurry-tree-img', 1, {
						filter: 'blur(0px)',
					}, {
						filter: 'blur(25px)',
						right: '-=125vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-cover-graphic-img', 1, {
						filter: 'blur(0px)',
					}, {
						filter: 'blur(25px)',
						right: '-=125vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .st6-text-block-1', 1, {
						top: '-=20vh',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .st6-text-block-2', 1, {
						top: '-=20vh',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .st6-text-block-3', 1, {
						top: '-=20vh',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-text-block-1', 0.9, {
						top: '-100vh'
					}, {
						top: '10vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-text-block-2', 1, {
						top: '100vh'
					}, {
						top: '46vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-text-block-3', 1, {
						right: '-19vw'
					}, {
						right: '15vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-white-box-1', 2, {
						y: '250%'
					}, {
						y: '80%',
						delay: 0.5,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st6-circle-img-1', 2, {
						x: '-120%',
						y: '120%'
					}, {
						x: '-120%',
						y: '-75%',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '200%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

		},



		'story-7': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles-2', 1, {
						y: '-=75vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#main .circles-2', 1, {
						y: '-=150vh',
						delay: 1,
						ease: Power3.easeInOut
					} ),

					TweenMax.to( '#screen1 .st7-title', 1, {
						top: '-=150vh',
						opacity: 0,
						filter: 'blur(25px)',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st7-title', 1, {
						filter: 'blur(0px)'
					}, {
						top: '-=55vh',
						opacity: 0.5,
						filter: 'blur(12.5px)',
						ease: Power3.easeInOut
					} ),

					TweenMax.to( '#screen1 .st7-holding-hands-img', 1, {
						top: '-=150vh',
						opacity: 0,
						filter: 'blur(25px)',
						delay: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st7-holding-hands-img', 1, {
						filter: 'blur(0px)'
					}, {
						top: '-=75vh',
						opacity: 0.5,
						filter: 'blur(12.5px)',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

		},



		'story-8': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles-2', 1, {
						x: '+=150vh',
						scale: 2,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1 .st8-cover-graphic-img-1', 1, {
						x: '+=150vh',
						scale: 2,
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#screen1 .st8-title', 1, {
						filter: 'blur(0px)'
					}, {
						opacity: 0,
						scale: 2,
						filter: 'blur(25px)',
						ease: Power3.easeInOut
					} ),
					TweenMax.fromTo( '#main .circles-3', 1, {
						x: '-175%',
						y: '50%',
						scale: 0.15
					}, {
						x: '-24%',
						y: '-48%',
						scale: 1,
						opacity: 1,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen1', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 150
					} ),
					TweenMax.to( '#screen2 .st8-text-block-1', 1, {
						top: '20vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st8-cover-graphic-img-2', 1, {
						right: '5vw',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st8-white-box-1', 1, {
						y: '60%',
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

			var tl2 = new TimelineMax()
				.add( [
					TweenMax.to( '#screen2 .st8-text-block-1', 1, {
						top: '-=130vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st8-cover-graphic-img-2', 1, {
						top: '-=100vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2 .st8-white-box-1', 1, {
						top: '-=110vh',
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#main .circles-3', 1, {
						y: '-=175vh%',
						opacity: 0,
						ease: Power3.easeInOut
					} ),
					TweenMax.to( '#screen2', 1, {
						zIndex: 100
					} ),
					TweenMax.to( '#screen3', 1, {
						zIndex: 150
					} ),
					TweenMax.to( '#screen3 .st8-video-wrapper', 1, {
						top: ( $( '#screen3 .st8-video-title' ).outerHeight() * -1 ),
						ease: Power3.easeInOut
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel2',
				triggerHook: 'onLeave',
				duration: '100%'
			} ).setPin( '#screen2' ).setTween( tl2 ).addTo( controller );

		},



		'story-9': function ( controller ) {

			var tl1 = new TimelineMax()
				.add( [
					TweenMax.to( '#main .circles-2', 1, {
						y: ( $( '#screen1 .st9-body-wrap' ).outerHeight() - ( $( window ).height() ) ) * -1,
						ease: Power3.easeNone
					} ),
					TweenMax.to( '#screen1', 3, {
						zIndex: 150
					} ),
					TweenMax.to( '#screen1 .st9-body-wrap', 1, {
						y: ( $( '#screen1 .st9-body-wrap' ).outerHeight() - ( $( window ).height() ) ) * -1,
						ease: Power3.easeNone
					} )
				] );

			new ScrollMagic.Scene( {
				triggerElement: '#panel1',
				triggerHook: 'onLeave',
				duration: '1000%'
			} ).setPin( '#screen1' ).setTween( tl1 ).addTo( controller );

		},


		'board-listing': function ( controller ) {},
		'letter-from-board-chair': function ( controller ) {},
		'letter-from-president-ceo': function ( controller ) {}

	};

	function handleUnload( controller ) {

		/*$( window ).off( 'scroll' );

		$( '#loader_percentage' ).html( '0%' );
		$( '#loader-wrap' ).show();

		$( 'body' ).find( ':not(#loader-wrap)' ).remove();
		$( 'body' ).addClass( 'loading' );

		//TweenMax.killAll();
		controller.destroy( true );
		controller = null;*/

	}

	function init() {

		// site controls
		$( window ).on( 'scroll', function () {

			var $win = $( this ),
				$si = $( '.scroll-indicator' ),
				w = $( window ).width();

			if ( w > 800 ) {

				if ( window.pageYOffset > 50 && !$si.hasClass( 'off' ) ) {
					$si.addClass( 'off' );
				} else if ( window.pageYOffset <= 50 ) {
					$si.removeClass( 'off' );
				}

			}

			// we need to turn off nav, if it's on!
			$( 'body' ).removeClass( 'nav-open' );
			$( '.hamburger' ).removeClass( 'close' );

			// handle next
			if ( $win.scrollTop() > 0 && $win.scrollTop() >= $( 'body' ).height() - $win.height() - 200 ) {
				$( 'body' ).addClass( 'scrolled' );
			} else {
				$( 'body' ).removeClass( 'scrolled' );
			}

		} ).trigger( 'scroll' );



		// navigation hamburger
		$( '.hamburger-link' ).on( 'click', function ( e ) {

			e.preventDefault();

			$( 'body' ).toggleClass( 'nav-open' );
			$( '.hamburger' ).toggleClass( 'close' );

		} );

		// handle loading/unloading
		$( '.preloading' ).addClass( 'loaded' ).removeClass( 'preloading' );
		$( 'body' ).removeClass( 'loading' );

		$( '#loader-wrap' ).fadeOut( 'fast', function () {

			$( '#loader-wrap' ).hide();

		} );

		// ---------------------------------------------------
		// Init ScrollMagic / Stories
		// ---------------------------------------------------
		var controller = new ScrollMagic.Controller( {
			globalSceneOptions: {
				triggerHook: 0
			}
		} );

		// handle animation for main logo
		var w = $( window ).width();
		var tl_logo = new TimelineMax()
			.add( [
				TweenMax.fromTo( '.logo', 0.5, {
					marginTop: -35,
					marginLeft: ( w > 800 ? -21 : -35 ),
					scale: ( w > 800 ? 1.25 : 1 ),
				}, {
					marginTop: ( w > 800 ? -90 : -75 ),
					marginLeft: ( w > 800 ? -83 : -80 ),
					scale: 0.50,
					ease: Power3.easeInOut
				} ),
				TweenMax.to( '#logo_icon', 0.5, {
					x: 12,
					y: 28,
					ease: Power3.easeInOut
				} ),
				TweenMax.fromTo( '#logo_text', 0.5, {
					opacity: 1
				}, {
					opacity: 0,
					ease: Power3.easeInOut
				} )
			] );

		new ScrollMagic.Scene( {
			/* jshint ignore:start */
			triggerElement: this,
			/* jshint ignore:end */
			duration: '100%'
		} ).setTween( tl_logo ).addTo( controller );

		if ( w > 800 ) {

			var story = $( 'body' ).prop( 'class' );

			$( 'a:not(.hamburger-link)' ).on( 'click', function () {
				return handleUnload( controller );
			} );

			window.onbeforeunload = function () {
				handleUnload( controller );
			};

			// handle page specific animations
			methods[ story ].call( undefined, controller );

			// need a way to recalc tweens on resize, so just reload
			/*$( window ).smartresize( function () {
				location.reload();
			} );*/

		}

	}

	// autosize iframes
	/*$( 'iframe' ).on( 'load', function () {
		var obj = $( this )[ 0 ];
		obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
	} );*/

	$( document ).ready( function () {

		imagesLoaded( 'body', {

			background: true

		} ).on( 'always', function () {

			init();

		} ).on( 'progress', function ( instance ) {

			$( '#loader_percentage' ).html( Math.round( ( instance.progressedCount / instance.images.length ) * 100 ) + '%' );

		} );

	} );

}( jQuery ) );
